<template>
  <main>
    <top-section :title="documents.name" />
    <div class="container">
      <documents-info
        v-for="(document, i) in documents.subcategories"
        :documents="document.documents"
        :title="document.name"
        :key="i"
      />
    </div>
  </main>
</template>

<script>
import TopSection from "@/components/TopSection";
import DocumentsInfo from "@/components/Documents/DocumentsInfo";

export default {
  name: "Documents",
  components: {
    DocumentsInfo,
    TopSection
  },

  beforeRouteUpdate(to, from, next) {
    this.key = to.params.name;
    next();
  },

  data: () => ({
    key: ""
  }),

  computed: {
    documents() {
      return (
        this.$store.getters.documentCategories.find(
          dc => dc.url === this.key
        ) || []
      );
    }
  },

  created() {
    this.key = this.$route.params.name;
  }
};
</script>
